/**
 * @file AppConstant.ts
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */

export const AppVersion = process.env.REACT_APP_APP_VERSION;

export const defaultLanguage = {code: "en", name: "English" };

export const AppLanguageList = [
    {code: "en", name: "English" }, {code: "es", name: "Spanish" }, {code: "de", name: "German" }, {code: "fr", name: "French" }, {code: "it", name: "Italian" },
    {code: "ja", name: "Japanese" }, {code: "nl", name: "Dutch" }, {code: "pt-PT", name: "Portuguese (Portugal)" }, {code: "pt-BR", name: "Portuguese (Brazil)" }, {code: "bg", name: "Bulgarian" },
    {code: "cs", name: "Czech" }, {code: "da", name: "Danish" }, {code: "el", name: "Greek" }, {code: "et", name: "Estonian" }, {code: "fi", name: "Finnish" },
    {code: "hr", name: "Croatian" }, {code: "hu", name: "Hungarian" }, {code: "is", name: "Icelandic" }, {code: "lv", name: "Latvian" }, {code: "lt", name: "Lithuanian" },
    {code: "nb", name: "Norwegian" }, {code: "pl", name: "Polish" }, {code: "ro", name: "Romanian" }, {code: "sk", name: "Slovak" }, {code: "sl", name: "Slovene" },
    {code: "sv", name: "Swedish" }, {code: "ar", name: "Arabic" }, {code: "zh", name: "Chinese" }, {code: "iw", name: "Hebrew" }, {code: "jko", name: "Korean" },
    {code: "ru", name: "Russian" }, {code: "sr", name: "Serbian" }, {code: "th", name: "Thai" }, {code: "tr", name: "Turkish" }, {code: "uk", name: "Ukrainian" }
]
export const AppName = "Patient Portal";

export const HelpEmail = "portal.help@bsci.com";

export const NoAdminFound  = "No administrator records were found associated with the clinic.";

export const NoClinicFound = "No clinic found.";

export const NoPatientFound = "No patient records were found associated with the clinic.";

export const SelectClinicWarning = "Kindly select the clinic";

export const LogoutMessage = "Your session has concluded; please proceed to log in again to resume your activities.";

export const NotAllowedToUsePortal = "To access the Patient portal, it is imperative to accept the terms of use and privacy policy. Without accepting these terms, access to the portal is not permitted.";

/** Admin Messages */
export const AdminCreatedSuccess = "Admin has been created successfully.";

export const AdminDeleteSuccess = "Admin has been deleted successfully.";

export const ResendAdminSuccess = "Admin has been re-invited successfully.";

export const PatientDeleteSuccsess = "Patient has been deleted successfully.";

export const PasswordSentSuccess = "Password has been sent successfully.";

export const AppExiosErros = new Map<string, string>( [
    [
        "ERR_NETWORK", "Error: Connectivity issue detected. Please verify your internet connection."
    ],
    [
        "ETIMEDOUT", "Error: Request timed out. Please verify your internet connection."
    ],
    [
        "ECONNABORTED", "Error: It appears that the server is unreachable."
    ]
])

